import { render, staticRenderFns } from "./ProfileScore.vue?vue&type=template&id=daea46b8&scoped=true&"
import script from "./ProfileScore.vue?vue&type=script&lang=ts&"
export * from "./ProfileScore.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileScore.vue?vue&type=style&index=0&id=daea46b8&scoped=true&lang=scss&"
import style1 from "./ProfileScore.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daea46b8",
  null
  
)

export default component.exports